export class OperativesDto{
    id?: number;
    username?: string;
}